import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { quotes } from "../../../../../../redux/quotes/action";
import { selectQuotesListItems } from "../../../../../../redux/quotes/selector";

const TransporterQuotes = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
    const orderItems = useSelector(selectQuotesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Message.category_name', headerName: 'Category Name',sortable: true, filter: true},
    { field: 'Message.quote.price.value', headerName: 'Quote price',isCurrencyValueFormat: true},
    { field: 'Message.CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat:true },
    { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedOn' ,isDateValueFormat:true},
        ]);
      }
      const fetchQuotes=()=>{
        dispatch(quotes.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes/list`,entity:'quotes',jsonData:{
          "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }}))
      } 
	useEffect(() => {
        createColumnDefs()
        fetchQuotes()
	}, [pageData])

	return (
   
	
		<Table columnData={columnDefs} rowData={orderItems?.result?.items}  setPageData={setPageData} 
    paginationData={orderItems?.result?.pagination} headingName="Quotes" />
       
     
	);
};

export default TransporterQuotes;


